import {stringify} from "qs";
import {sign} from "./api/sign";
import {login, balanceQuery, transfer} from './api/login'
import axios from "axios";
import getAccounts from './config/accounts'

let initBalance = 1000

!function () {
    function getQueryVariable(variable) {
        let href = window.location.href.split('#')[0]
        let query = href.substring(href.indexOf('?')+1);
        let vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }
    function loginFun(type, form) {
        // 语言
        let lang = getQueryVariable('lang')
        // 彩种
        let ticketId = getQueryVariable('ticketId')
        // 大厅
        let currentHallType = getQueryVariable('currentHallType')
        if(currentHallType) {
            const banlanceMap = {
                1: 1000,
                2: 1000,
                3: 100000000,
                4: 10000,
                5: 10000,
                6: 200000,
            }
            initBalance = banlanceMap[currentHallType]
        }

        balanceQuery(sign({
            member: form.account,
            merchant: form.merchantAccount,
            timestamp: new Date() - 0,
        })).then(r => {
            if(!r.sucess) {
                document.write('登录失败')
                return
            }

            let loginParams = sign({
                member: form.account,
                password: form.password,
                merchant: form.merchantAccount,
                timestamp: new Date() - 0,
            })

            if(lang) {
                loginParams.lang = lang
            }
            if(ticketId) {
                loginParams.ticketId = ticketId
            }
            if(currentHallType) {
                loginParams.currentHallType = currentHallType
            }

            let requests = [
                login(stringify(loginParams))
            ]

            const transferAmount = parseFloat(r.data.amount) - initBalance
            if(transferAmount !== 0) {
                requests.push(
                    transfer(sign({
                        member: form.account,
                        merchantAccount: form.merchantAccount,
                        transferType: transferAmount > 0 ? 2 : 1,
                        amount: Math.abs(transferAmount),
                        notifyId: Math.random().toString(36).substr(2),
                        timestamp: new Date() - 0,
                    })),
                )
            }
            axios.all(requests).then(axios.spread((r1) => {
                if (r1.sucess) {
                    const loginUrl = type === 1 ? r1.data.pc : r1.data.h5
                    location.href = `${loginUrl}`
                } else {
                    document.write('登录失败')
                }
            }))
        })
    }
    function isMobile() {
        const userAgentInfo = navigator.userAgent.toLowerCase();
        const Agents = ["android","iphone",
            "symbianos", "windows phone",
            "ipad", "ipod"];
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) >= 0) {
                return true
            }
        }
        return false
    }
    loginFun(isMobile() ? 2 : 1, getAccounts(getQueryVariable('currentHallType')))
}()
